import React, { useCallback, useMemo, } from 'react';
import { ADD_ROW, JSON_KEY_TIME, 
   // TABLE_HEADER_ID, JSON_KEY_ID, 
   TABLE_HEADER_TYPE, JSON_KEY_RESULTS_TYPE, MESSAGES_TYPE_SENT_MESSAGE, MESSAGES_NAME_SENT_MESSAGE,
   TABLE_HEADER_TIME, JSON_KEY_MESSAGE, UNKNOWN, TABLE_HEADER_MESSAGE} 
from '../../common/common';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';

const Messages = () => {
   function ConvertMessagesType(type) {
      switch (type) {
         case MESSAGES_TYPE_SENT_MESSAGE:
            return MESSAGES_NAME_SENT_MESSAGE;
         default:
            return UNKNOWN;
      }
   }
   
   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[MessagesTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[MessagesTable] Row Double Clicked:`, rowData);
   }, []);

   const handleEvents = useCallback((details, setLocalTableData) => {
      // console.log('results details: ', details.data, 'r_type:', details.data.r_type, ', Message:', details.data.message, ', message:', JSON.stringify(details.data.message));

      const modifiedRow = {
         ...details.data,
         id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
         message: JSON.stringify(details.data.message),
         r_type: ConvertMessagesType(details.data.r_type),
      };

      switch (details.type) {
         case ADD_ROW:
            // console.log(`Results adding message with id ${modifiedRow}.`);
            setLocalTableData(prev => {
               const exists = prev.some(row => row.id === modifiedRow.id);
               if (exists) {
                  console.log(`Duplicate message with id ${modifiedRow.id} ignored.`);
                  return prev;
               }
               return [...prev, modifiedRow];
            });
            break;

         default:
            console.log('Unknown event type:', details.type);
            break;
      }
   }, []);

   const columns = useMemo(() => [
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID }, // don't show it but it is still there
      { Header: TABLE_HEADER_TIME, accessor: JSON_KEY_TIME },
      { Header: TABLE_HEADER_TYPE, accessor: JSON_KEY_RESULTS_TYPE },
      { Header: TABLE_HEADER_MESSAGE, accessor: JSON_KEY_MESSAGE },
   ], []);

   return (
      <VirtualizedTablesTemplate
         columns={columns}
         eventHandlers={handleEvents}
         tableName="MessagesTable"
         onRowClick={handleSingleClick}
         onRowDoubleClick={handleDoubleClick}
         highlightOnClick={true}
         enableSearch={true}

      />
   );
};

export default Messages;
